// extracted by mini-css-extract-plugin
module.exports = {"login":"login_login__lYX8Y","dropdown-menu":"login_dropdown-menu__iDYcC"};